module.exports = __webpack_public_path__ + "img/bc85834d72c220f85cffcab1d992a41.171ad120.jpg";